import { Link } from "react-router"
import FormFooter from "../../core/common/formFooter"
import { useEffect, useState } from "react"
import PreLoader from "../../core/common/preLoader"
import { Role } from "../../types/dataModel"
import CommonSelectV2 from "../../core/common/commonSelectV2"
import useFetch from "../../hooks/useFetch"
import { getAPIHeaders, isNotEmpty } from "../../common/Utils"
import { API } from "../../common/Constants"


const STATUS:any[] = [{label:'ACTIVE', value: 'ACTIVE'},{label:'INACTIVE', value: 'INACTIVE'}]

interface Props {
    onSuccess?: ()=>void
    onCancel?: ()=>void
    role?: Role
    readonly?: boolean
}
const ModifyRole = ({onSuccess, role, onCancel, readonly}:Props) => {
    const [showMsgBox, setShowMsgBox] = useState<boolean>(false)
    const [formData, setFormData] = useState<Role>()
    const [errorMessage, setErrorMessage] = useState<string | undefined>("");
    const { isLoading, error, status, data, callFetch } = useFetch();
    
    useEffect(()=>{
        setFormData(role)
    },[role])

    useEffect(() => {
        if(data && status && status < 299){
            reset()
            setErrorMessage('')
            setShowMsgBox(true)
            if(onSuccess){
                onSuccess()
            }
        }
   }, [status]);

   useEffect(() => {
    if(error){
      if(error.response?.data){
        setErrorMessage(error.response?.data)
      } else{
        setErrorMessage('Something went wrong please try again later.')
      }
    }
    }, [error]);

    const reset = () => {
        setFormData({
          name:"",
          description:"",
          status:""
        })
        setShowMsgBox(false)
        setErrorMessage('')
    }

    const onExit= () => {
        reset()
        if(onCancel){
            onCancel()
        }
    }

    const onSave = (e: any) => {
        e.preventDefault()
        if (!isNotEmpty(formData?.name)) {
            setErrorMessage("Please provide name")
        } else if (!isNotEmpty(formData?.description)) {
            setErrorMessage("Please provide description")
        } else if (!isNotEmpty(formData?.status)) {
            setErrorMessage("Please select a status")
        } else {
            setErrorMessage("")
            callFetch( formData?.id?  `${API.ROLE}/${formData?.id}` : API.ROLE,
                formData?.id ? 'PUT' : 'POST',
                getAPIHeaders(),
                null,
                {
                    ...formData
                }
            ).catch((err) => {});
        }
    }
    
    const renderForm = () => {
        return (
            <>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">Role</h4>
                        <button
                            type="button"
                            className="btn-close custom-btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={()=>{
                                onExit()
                            }}
                        >
                            <i className="ti ti-x" />
                        </button>
                    </div>
                    <form action="">
                        <div className="modal-body pb-0">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label className="form-label">Role Name <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" 
                                        value={formData?.name}
                                        disabled={readonly}
                                        onChange={(e:any)=>{
                                            setFormData({
                                                ...formData,
                                                name: e?.target?.value
                                            })
                                        }}/>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label className="form-label">Description <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control"
                                                value={formData?.description}
                                                disabled={readonly}
                                                onChange={(e: any) => {
                                                    setFormData({
                                                        ...formData,
                                                        description: e?.target?.value
                                                    })
                                                }} />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="mb-3 ">
                                        <label className="form-label">Status <span className="text-danger">*</span></label>
                                        <CommonSelectV2
                                            disabled={readonly}
                                            className='select'
                                            options={STATUS}
                                            defaultValue={STATUS.find((item)=> formData?.status === item?.value )}
                                            onChange={(value:any) => {
                                                setFormData({
                                                    ...formData,
                                                    status: value
                                                })
                                            }} 

                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            {
                                readonly ? <></> 
                                : <FormFooter error={true} message={errorMessage} onCancel={onExit} onSave={onSave} />
                            }
                            
                        </div>
                    </form>
                </div>
            </div>
            </>
        )
    }

    const renderMsgBox = () => {
        return (          
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
                {
                    errorMessage
                    ?
                    <>
                        <span className="avatar avatar-xl bg-transparent-danger text-danger mb-3">
                            <i className="ti ti-alert-triangel fs-36" />
                        </span>
                        <h4 className="mb-1">Role {formData?.id ? 'Updated' : 'Added'} Failed</h4>
                        <p className="mb-3">
                            {errorMessage}.
                        </p>
                    </>
                    :
                    <>
                    <span className="avatar avatar-xl bg-transparent-success text-success mb-3">
                        <i className="ti ti-thumb-up fs-36" />
                    </span>
                    <h4 className="mb-1">Role Saved Successfull</h4>
                    <p className="mb-3">
                        Role is saved  successfully.
                    </p>
                    </>
                }

                <div className="d-flex justify-content-center">
                    <Link to="#" 
                        data-bs-dismiss="modal" 
                        className="btn btn-success"
                        onClick={()=>{
                          setTimeout(() => {
                            setShowMsgBox(false);
                          }, 1000);
                          }}>
                        Close
                    </Link>
                </div>
            </div>
        </div>
      </div>)
    }

    return (
        <div className="modal fade" id="modify_role"  
            data-bs-backdrop="static"
            data-bs-keyboard="false">
            <PreLoader showLoader={isLoading} />
            {showMsgBox ? renderMsgBox() : renderForm()}
        </div>
    )

}

export default ModifyRole